import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(d)
}

export function formatDateTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(d)
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(amount)
}

export function formatMonthYear(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date
  const formatted = new Intl.DateTimeFormat('fr-FR', {
    month: 'long',
    year: 'numeric'
  }).format(d)
  return formatted.charAt(0).toUpperCase() + formatted.slice(1)
}

export function getMonthKey(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  return `${year}-${month}`
}

export function getMaxBudget(budgetHypotheses: unknown, budgetPrevisionnel?: number | null): number | null {
  try {
    const arr = typeof budgetHypotheses === 'string'
      ? JSON.parse(budgetHypotheses)
      : budgetHypotheses
    if (Array.isArray(arr) && arr.length > 0) {
      const nums = arr.map(Number).filter((n) => !isNaN(n) && n > 0)
      if (nums.length > 0) return Math.max(...nums)
    }
  } catch {}
  if (budgetPrevisionnel != null && Number(budgetPrevisionnel) > 0) {
    return Number(budgetPrevisionnel)
  }
  return null
}
